var CryptoJS = require('crypto-js')

var key = 'c7kNyuUS9Xs4gE4ByZAFYnzwksRZ9grw'

export function encryption(data) {
	// JSON形式を文字列に
	if('string' != typeof(data)){
		data = JSON.stringify(data)
	}
	data = btoa(unescape(encodeURIComponent(data)))
	var encrypted = CryptoJS.AES.encrypt(data, key)
	return encrypted.toString()
}

export function decryption(data) {
	var decrypt = CryptoJS.AES.decrypt(data, key)
	return decodeURIComponent(escape(window.atob(decrypt.toString(CryptoJS.enc.Utf8))))
}
